import { isArray, isObject, isString, isNumber, isFunction } from 'lodash';

/**
 * Static methods to ensure a value is of a particular type
 */
export class ensure {
	/**
	 * If value is an Array, return it; otherwise return the given default value
	 * @param {*} value
	 * @param {Array} defaultValue
	 * @returns {Array}
	 */
	static array(value, defaultValue = []) {
		return isArray(value) ? value : defaultValue;
	}

	/**
	 * If value is an Object, return it; otherwise return the given default value
	 * @param {*} value
	 * @param {Object} defaultValue
	 * @returns {Object}
	 */
	static object(value, defaultValue = {}) {
		return isObject(value) ? value : defaultValue;
	}

	/**
	 * If value is a String, return it; otherwise return the given default value
	 * @param {*} value
	 * @param {String} defaultValue
	 * @returns {String}
	 */
	static string(value, defaultValue = '') {
		return isString(value) ? value : defaultValue;
	}

	/**
	 * If the value is a String, run parseFloat(); if value is a Number, return it; otherwise return the given default value
	 * @param {*} value
	 * @param {Number} defaultValue
	 * @returns {Number}
	 */
	static number(value, defaultValue = 0) {
		return isString(value) ? parseFloat(value) : isNumber(value) ? value : defaultValue;
	}

	/**
	 * If value is a finite Number, return it; otherwise return the given default value
	 * @param {*} value
	 * @param {Number} defaultValue
	 * @returns {Number}
	 */
	static finite(value, defaultValue = 0) {
		var num = ensure.number(value, defaultValue);
		return isFinite(num) ? num : defaultValue;
	}

	/**
	 * If value is a member of the given list, return it; otherwise return the given default value
	 * @param {*} value
	 * @param {Array} allowedValues
	 * @param {*} defaultValue
	 * @returns {*}
	 */
	static oneOf(value, allowedValues, defaultValue) {
		return ensure.array(allowedValues).indexOf(value) == -1 ? defaultValue : value;
	}

	/**
	 * If value is a Promise, return it. Otherwise return the value inside a resolved promise
	 * @param {*} value
	 * @returns {Promise}
	 */
	static promise(value) {
		if (isObject(value) && isFunction(value.then)) {
			return value;
		}
		return Promise.resolve(value);
	}

	/**
	 * Attempt to interpret the given value as a hex color, converting it if needed
	 * @param {*} value   A string such as #FF0000, #F00, FF0000
	 * @param {*} defaultValue
	 * @returns {*}  A six-character color string prefixed with a #
	 */
	static colorHex(value, defaultValue = '#000000') {
		value = ensure.string(value);
		value = value.replace(/^#/, '');
		if (/^[a-f0-9]{3}$/i.test(value)) {
			value = value[0] + value[0] + value[1] + value[1] + value[2] + value[2];
		}
		return /^[a-f0-9]{6}/i.test(value) ? '#' + value.slice(0, 6) : defaultValue;
	}
}
